// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "waiting-TWg8s";
export { _1 as "__esModule", _2 as "waiting" }
export default { "__esModule": _1, "waiting": _2 }
